export default __webpack_public_path__ + "static/media/shield.403d4e10.svg";